// @ts-nocheck
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Typography,
} from "@mui/material";
import * as Yup from "yup";
import { useFormik } from "formik";
import { getCssVariableHandler } from "../../utils/styles/getCssVariables";

import editNoteModalStyles from "./editNoteModal.module.css";
import {
  CustomTextFiled,
} from "../../components/Custom/Input";

const EditNoteModal = ({ 
  successCallback,
  closeModalHandler, sessionId, positionId,
  content
}) => {
  // Redux hooks...
  const dispatch = useDispatch();

  // Static data start...
  const initialValues = React.useMemo(() => {
    return {
      eventNotes: "",
    };
  }, []);
  // Static data end...

  // Selectors start...
  const auth = useSelector((store) => store.auth);
  const reportedIssues = useSelector((store) => store.reportedIssues);
  // Selectors end...

  // Form schema starts...
  const formSchema = Yup.object().shape({
    eventNotes: Yup.string()
    .max(1000, "Note should have at most 1000 characters!")
    .required("Note is required!"),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: formSchema,
    onSubmit: (values) => {
      successCallback(values);
    },
  });

  const {
    values,
    setValues,
    setFieldValue,
    dirty,
    handleChange,
    handleBlur,
    touched,
    errors,
    submitForm,
    resetForm,
  } = formik;
  // Form schema end...

  // useEffect start...
  React.useEffect(() => {
    setValues(values => {
      return {
        ...values,
        eventNotes: content
      }
    })
  }, [content]);

  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: "2rem",
            marginBottom: "3rem",
          }}
        >
          Edit Note
        </Typography>

        <Box className={editNoteModalStyles?.formDataBox}>
          <Grid
            container
            spacing={2}
            sx={{
              height: "100%",
              overflowY: "auto",
            }}
            className={"custom-scroll-design"}
          >
            <Grid item xs={12}>
              <Box className={editNoteModalStyles["form-box"]}>
                <CustomTextFiled
                  fullWidth
                  placeholder="Write here..."
                  name="eventNotes"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.eventNotes}
                  multiline={true}
                  rows={3}
                  sx={{
                    height: "fit-content !important",
                  }}
                />
                {touched.eventNotes && errors.eventNotes && (
                  <span className={editNoteModalStyles.error}>
                    {errors.eventNotes}
                  </span>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>

        <Box
          className={editNoteModalStyles.bottomBtnBox}
          sx={{
            justifyContent: "space-between",
          }}
        >
          <Button
            // disableRipple={createContactInfo?.loading}
            // className={styles.btnNext}
            // onClick={() => {
            //     if (createContactInfo?.loading) return;
            //     submitForm()
            // }}
            sx={{
              width: "49%",
              background: getCssVariableHandler({
                variableName: "--red-shade-1rgb",
              }),
            }}
            onClick={() => {
              submitForm();
            }}
          >
            {reportedIssues?.addIssueInPosition?.isRequestLoading ? (
              <CircularProgress size={22} style={{ margin: "0px 3.5px" }} />
            ) : (
              "Save"
            )}
          </Button>

          <Button
            // disableRipple={createContactInfo?.loading}
            // className={styles.btnNext}
            // onClick={() => {
            //     if (createContactInfo?.loading) return;
            //     submitForm()
            // }}
            sx={{
              width: "49%",
              background: "transparent",
              border: `1px solid ${getCssVariableHandler({
                variableName: "--font-rgb",
              })}`,
            }}
            onClick={() => {
              closeModalHandler();
            }}
          >
            {/* {createContactInfo?.loading ? (
                        <CircularProgress size={22} style={{ margin: "0px 3.5px" }} />
                    ) : ( */}
            Cancel
            {/* )} */}
          </Button>
        </Box>
      </Box>
    </>
  );
};

EditNoteModal.propTypes = {
  closeModalHandler: PropTypes.func,
  sessionId: PropTypes.string,
  positionId: PropTypes.string,
  content: PropTypes.string
};

export default EditNoteModal;